import { projectService } from '@/service/project';
export interface ProjectData {
  name: string,
  slug: string,
  description: string,
  icon?: string,
  created?: Date,
  updated?: Date,
  [key: string]: string | Date | undefined;
}

export class Project {
  constructor(private org_slug: string, private slug?: string) {}

  async all(): Promise<ProjectData[] | undefined> {
    try {
      return await projectService.getAll(`${this.org_slug}`) as ProjectData       [];
    } catch (e) {
      console.warn(e);
    }
  }

  async get(): Promise<ProjectData | undefined> {
    try {
       return await projectService.getOne(`${this.org_slug}` ,`${this.slug}`) as ProjectData;
    } catch (e) {
      console.warn(e);
    }
  }

  async add(project: ProjectData): Promise<string | undefined> {
    try {
      return await projectService.add(this.org_slug, project);
    } catch (e) {
      console.warn(e);
    }
  }

  async update(project: ProjectData): Promise< string | undefined> {
    if (!this.slug) return;
    try {
      return await projectService.update(this.org_slug, this.slug, project);
    } catch (e) {
      console.warn(e);
    }
  }

  async delete(): Promise<boolean> {
    if (!this.slug) return false;
    try {
      return await projectService.delete(this.org_slug, this.slug);
    } catch (e) {
      console.warn(e);
      return false;
    }
  }
}

